export enum GovernanceVoteTipping {
  Disabled = 'Disabled',
  Early = 'Early',
  Strict = 'Strict',
}
